// styles to tailwind css classes
export const tailwindStyles = {
  portal:
    'bg-transparent fixed left-0 top-0 right-0 bottom-0 h-screen z-40 pointer-events-none',
  wrapper: 'w-screen h-screen',
};
